import { tags } from '../tagNames';
import { useUserTags } from '../useUserTags';

export const useLiveOpsControl = () => {
	const { userTags, isLoading } = useUserTags();
	const isLiveOpsGlobalControl = userTags.includes(tags.liveopsGlobalControl);

	return [isLiveOpsGlobalControl, isLoading];
};
